import { RadioGroup, RadioOption } from '@all-manager/design-system-v2';
import type { ChangeEvent, FocusEvent } from 'react';
import { ROLE_DESCRIPTIONS, ROLE_LABELS, ROLE_OPTIONS } from '../../constants/roles';
import type { UserRole } from '../../types';

type Props = {
  name: string;
  value: UserRole;
  onChange: (event: ChangeEvent<HTMLInputElement>, value: string) => void;
  onBlur?: (event: FocusEvent<HTMLDivElement>) => void;
};

export default function RoleField(props: Props) {
  return (
    <RadioGroup
      label="Rôle"
      name={props.name}
      value={props.value}
      onChange={props.onChange}
      onBlur={props.onBlur}
    >
      {ROLE_OPTIONS.map((role) => (
        <RadioOption
          key={role}
          value={role}
          label={ROLE_LABELS[role]}
          description={ROLE_DESCRIPTIONS[role]}
        />
      ))}
    </RadioGroup>
  );
}
